import RevealText from "@/components/shared/RevealText";
import Solutions from "@/components/home/Solutions";
import Manifesto from "@/components/home/Manifesto";
import FinalCta from "@/components/home/FinalCta";
import { useLang } from "@/i18n/LanguageContext";
import SEO from "@/components/shared/SEO";

export default function SolutionsPage() {
  const { t } = useLang();
  return (
    <main data-testid="solutions-page" className="bg-black text-white">
      <SEO title={t.seo.solutions.title} description={t.seo.solutions.desc} />
      <section className="pt-40 md:pt-56 pb-16 border-b border-white/10">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10">
          <p className="font-mono-eyebrow text-[var(--dp-accent)] mb-8">{t.solutions.eyebrow}</p>
          <RevealText
            lines={[t.solutions.title]}
            className="font-display text-5xl md:text-7xl lg:text-[104px] leading-[0.9] tracking-tighter font-medium"
          />
          <p className="mt-10 max-w-2xl text-neutral-300 text-lg md:text-xl leading-relaxed">
            {t.solutions.body}
          </p>
        </div>
      </section>
      <Solutions showHeader={false} />
      <Manifesto />
      <FinalCta />
    </main>
  );
}
